import React, { useEffect, useState } from 'react'
import { Box, Collapse, Typography } from '@material-ui/core'
import {
  ChevronDown as ChevronDownIcon,
  Zap as ZapIcon,
  Tool as ToolIcon,
} from 'react-feather'

import { DaiStepIcon, StepItem } from './components'

import dai from 'constants/dai'
import useStyles from './styles'

const ToolActivity = ({
  completedTools = [],
  phase,
  activeToolName,
  streaming,
}) => {
  const classes = useStyles()
  const [expanded, setExpanded] = useState(true)

  useEffect(() => {
    if (!streaming) setExpanded(false)
  }, [streaming])

  const isActive = streaming && phase !== null
  const showActiveStep = isActive && phase !== 'generating'
  const hasAnyActivity =
    completedTools.length > 0 ||
    phase === 'thinking' ||
    phase === 'tool_calling' ||
    phase === 'tool_done'

  const getToolFriendlyName = (name) => {
    if (!name) return 'Ferramenta'
    return (
      dai.tools.names[name] ||
      name.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
    )
  }

  const getCategoryLabels = (toolName) => {
    const category = dai.tools.categories[toolName]
    return category ? dai.tools.categoryLabels[category] : null
  }

  const getStepIcon = (toolName) => {
    const category = dai.tools.categories[toolName]
    if (category === 'agent_transfer') return DaiStepIcon
    return dai.tools.categoryIcons[category] || ToolIcon
  }

  const getActiveStepLabel = () => {
    if (phase === 'thinking') return 'Pensando...'

    const toolName =
      phase === 'tool_calling'
        ? activeToolName
        : completedTools[completedTools.length - 1]

    const labels = getCategoryLabels(toolName)
    const friendlyName = getToolFriendlyName(toolName)

    if (phase === 'tool_calling') {
      return labels
        ? `${labels.calling} ${friendlyName}`
        : `Consultando ${friendlyName}`
    }

    if (phase === 'tool_done') {
      return labels
        ? `${labels.done} ${friendlyName}`
        : 'Processando resultado...'
    }

    return ''
  }

  const getHeaderLabel = () => {
    const total = completedTools.length + (showActiveStep ? 1 : 0)
    const stepLabel = total === 1 ? 'etapa' : 'etapas'

    if (streaming) return `Processando (${total} ${stepLabel})`
    return `Concluído (${completedTools.length} ${stepLabel})`
  }

  const allSteps = [
    ...completedTools.map((tool) => ({
      key: tool,
      label: getToolFriendlyName(tool),
      Icon: getStepIcon(tool),
      isActive: false,
    })),
    ...(showActiveStep
      ? [
          {
            key: 'active',
            label: getActiveStepLabel(),
            Icon: phase === 'thinking' ? ZapIcon : null,
            isActive: true,
          },
        ]
      : []),
  ]

  if (!hasAnyActivity) return null

  return (
    <Box className={classes.container}>
      <Box
        className={classes.header}
        onClick={() => setExpanded((prev) => !prev)}
      >
        <ChevronDownIcon
          size={16}
          className={`${classes.chevron} ${
            expanded ? classes.chevronExpanded : ''
          }`}
        />
        <Typography className={classes.headerTitle}>
          {getHeaderLabel()}
        </Typography>
      </Box>

      <Collapse in={expanded}>
        <Box className={classes.stepsList}>
          {allSteps.map(({ key, label, Icon, isActive }, i) => (
            <StepItem
              key={key + i}
              label={label}
              Icon={Icon}
              isActive={isActive}
              isLast={i === allSteps.length - 1}
            />
          ))}
        </Box>
      </Collapse>
    </Box>
  )
}

export default ToolActivity
